import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, Sparkles } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken] = useState(94);
  const [timeLeft, setTimeLeft] = useState({
    h: 22,
    m: 56,
    s: 44
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-brand-purpleDark via-brand-purple to-brand-purpleDark text-white shadow-md border-b border-brand-gold/30" data-id="element-422" data-mp="3b66fg7tsaa0k">
      <div className="max-w-7xl mx-auto px-3 py-2 md:px-6 md:py-2.5" data-id="element-423" data-mp="1gv18atjhnfgh">
        {/* Mobile marquee */}
        <div className="md:hidden overflow-hidden relative" data-id="element-424" data-mp="27gaw3kqyn3n9">
          <motion.div className="flex items-center gap-6 whitespace-nowrap text-[11px] font-medium w-max" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 18,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-425" data-mp="22nhperbxll8j">
            {[0, 1].map(dup => <div key={dup} className="flex items-center gap-6 shrink-0" data-id="element-426" data-mp="2qb7zwve02ium">
                <div className="flex items-center gap-1.5 shrink-0 text-brand-goldLight" data-id="element-427" data-mp="2lfaismuwx8gs">
                  <Clock className="w-3.5 h-3.5 shrink-0" data-id="element-428" data-mp="2gdtlf1bn044y" />
                  <span data-id="element-429" data-mp="2cecee3gkayxo">Precio de lanzamiento cierra en</span>
                  <span className="font-mono font-bold tabular-nums bg-white/15 rounded px-1.5 py-0.5 ml-0.5 text-white" data-id="element-430" data-mp="2cfvy641ffs47">
                    {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
                  </span>
                </div>
                <span className="w-1 h-1 rounded-full bg-brand-goldLight/50 shrink-0" data-id="element-431" data-mp="12fjnvokckrjv" />
                <div className="flex items-center gap-1.5 shrink-0" data-id="element-432" data-mp="17fft1r4s6p10">
                  <Sparkles className="w-3.5 h-3.5 shrink-0 animate-pulse text-brand-goldLight" data-id="element-433" data-mp="17cjvw50rc4dm" />
                  <span data-id="element-434" data-mp="sjzub8t9a4ya">
                    <strong className="tabular-nums text-brand-goldLight" data-id="element-435" data-mp="xggl6aruaxf2">
                      {spotsTaken}%
                    </strong>{' '}
                    de cupos tomados
                  </span>
                </div>
                <span className="w-1 h-1 rounded-full bg-brand-goldLight/50 shrink-0" data-id="element-436" data-mp="oh3grwikoz17" />
                <a href="#pricing" className="inline-flex items-center gap-1 bg-brand-goldLight text-brand-purpleDark font-bold px-2.5 py-0.5 rounded-full text-[11px] shrink-0" data-id="element-437" data-mp="9rxaxpp8cakc">
                  Ver kit →
                </a>
              </div>)}
          </motion.div>
        </div>

        {/* Desktop */}
        <div className="hidden md:flex items-center justify-center gap-3 md:gap-6 text-[11px] md:text-sm font-medium" data-id="element-438" data-mp="3i94x59vj2gir">
          <div className="flex items-center gap-1.5 md:gap-2 whitespace-nowrap text-brand-goldLight" data-id="element-439" data-mp="3dalg9nvsjux9">
            <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 shrink-0" data-id="element-440" data-mp="3ra3686ktpe87" />
            <span className="hidden sm:inline" data-id="element-441" data-mp="3maq7ooklaips">
              Precio de lanzamiento cierra en
            </span>
            <span className="sm:hidden" data-id="element-442" data-mp="52d1vzvuwf0k">Cierra en</span>
            <span className="font-mono font-bold tabular-nums bg-white/15 rounded px-1.5 py-0.5 ml-0.5 text-white" data-id="element-443" data-mp="50s7ca9jkw2p">
              {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
            </span>
          </div>
          <div className="hidden md:block w-px h-4 bg-brand-goldLight/40 shrink-0" data-id="element-444" data-mp="dwretvswzdgi" />
          <div className="hidden md:flex items-center gap-2 whitespace-nowrap" data-id="element-445" data-mp="9u4qw5zd6col">
            <Sparkles className="w-4 h-4 shrink-0 animate-pulse text-brand-goldLight" data-id="element-446" data-mp="ntmbe95mn3s5" />
            <span data-id="element-447" data-mp="iv2reealg22f">
              <strong className="tabular-nums text-brand-goldLight" data-id="element-448" data-mp="ivuknigpxnpj">
                {spotsTaken}%
              </strong>{' '}
              de cupos tomados
            </span>
          </div>
          <a href="#pricing" className="hidden sm:inline-flex items-center gap-1 bg-brand-goldLight text-brand-purpleDark font-bold px-3 py-1 rounded-full text-[11px] md:text-xs hover:bg-white transition-colors shrink-0" data-id="element-449" data-mp="16w6b7ueg19ln">
            Ver kit →
          </a>
        </div>
      </div>
    </div>;
}